const REFRESH_DATA = "REFRESH_DATA";

// Define reducer function
const refreshDataReducer = (state = { refreshSession: true }, action) => {
  switch (action.type) {
    case REFRESH_DATA:
      return {
        refreshSession: !state.refreshSession,
      };
    default:
      return state;
  }
};

const refreshSessionData = () => ({
  type: REFRESH_DATA,
});

export { refreshSessionData };
export default refreshDataReducer;
